// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1422":"b5ca35ea","7742":"71dcd781","8588":"4570c3b6","9304":"4570c3b6"}[chunkId] + ".chunk.css";
};